"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StaffModePreScripting = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _components = require("@PetSureAustralia/petsure-react-ui-library/distLib/components");
var _frequencySelector = require("../quoteControls/frequencySelector");
var _quoteHelpers = require("../../helpers/quoteHelpers");
var _tableContext = require("../productsTable/stateHelpers/tableContext");
var _staffModeHelpers = require("./staffModeHelpers");
var _staffCoverOptionsMessage = require("./staffCoverOptionsMessage");
require("./staffInstructions.scss");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var StaffModePreScripting = exports.StaffModePreScripting = function StaffModePreScripting(_ref) {
  var quotesContext = _ref.quotesContext,
    formContext = _ref.formContext,
    dataIsUpdating = _ref.dataIsUpdating,
    onPaymentFrequencyChange = _ref.onPaymentFrequencyChange,
    _ref$onExpertModeChan = _ref.onExpertModeChange,
    onExpertModeChange = _ref$onExpertModeChan === void 0 ? function () {} : _ref$onExpertModeChan;
  var _useContext = (0, _react.useContext)(_tableContext.TableContext),
    _useContext$tableCont = _useContext.tableContext,
    ProductGroupsKeyedByPlanNumber = _useContext$tableCont.ProductGroupsKeyedByPlanNumber,
    staffInstructions = _useContext$tableCont.staffInstructions,
    speciesFilter = _useContext$tableCont.speciesFilter,
    _useContext$tableStat = _useContext.tableState,
    activeProductGroup = _useContext$tableStat.activeProductGroup,
    visiblePlans = _useContext$tableStat.visiblePlans,
    staffMode = _useContext$tableStat.staffMode,
    staffExpertMode = _useContext$tableStat.staffExpertMode;
  var hasActiveProductGroup = activeProductGroup && activeProductGroup.productsGroups.length > 0;
  var staffPlansToDiscuss = (0, _staffModeHelpers.GetStaffPlansToDiscuss)({
    visiblePlans: visiblePlans,
    ProductGroupsKeyedByPlanNumber: ProductGroupsKeyedByPlanNumber,
    hasActiveProductGroup: hasActiveProductGroup,
    activeProductGroup: activeProductGroup
  });
  var HandleExpertModeChange = function HandleExpertModeChange(newMode) {
    onExpertModeChange(newMode);
  };
  if (!staffMode) {
    return null;
  }
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "staffModePreScript staffInstructionsPanel ".concat(staffExpertMode ? 'expertMode' : '')
  }, /*#__PURE__*/_react["default"].createElement(_components.SectionWrapper, {
    isOpen: true,
    openIcon: 'plus',
    closeIcon: 'tick',
    heading: 'Introductory script',
    customCssClass: 'introductoryScript'
  }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("p", {
    className: "guideNotes bold"
  }, "Confirm and enter the following details with the customer:"), /*#__PURE__*/_react["default"].createElement("p", {
    className: "staffScriptItem"
  }, "Pet insurance is a 12 month contract and you can pay your premium fortnightly, monthly or yearly."), /*#__PURE__*/_react["default"].createElement("p", {
    className: "staffScriptItem"
  }, "How would you like to quote your premiums?"), /*#__PURE__*/_react["default"].createElement("div", {
    className: "staffPaymentFrequencySelector"
  }, /*#__PURE__*/_react["default"].createElement(_frequencySelector.FrequencySelector, {
    selectedFrequency: quotesContext.paymentFrequencyCode,
    collectionFee: quotesContext.collectionFee,
    dataIsUpdating: dataIsUpdating,
    formContext: formContext,
    onPaymentFrequencyChange: onPaymentFrequencyChange
  })), /*#__PURE__*/_react["default"].createElement("p", {
    className: "highAccuracy"
  }, "What cover would you like to select today?"), /*#__PURE__*/_react["default"].createElement("p", {
    className: "guideNotes"
  }, /*#__PURE__*/_react["default"].createElement("strong", null, "You may ", hasActiveProductGroup ? 'only' : '', " discuss\xA0", staffPlansToDiscuss.map(function (plan, index) {
    return /*#__PURE__*/_react["default"].createElement("span", {
      key: "staffPlansToDiscuss_".concat(plan.planNumber)
    }, plan.externalName, (0, _staffModeHelpers.GetSeparator)({
      fullNumber: staffPlansToDiscuss.length,
      index: index
    }));
  }))), /*#__PURE__*/_react["default"].createElement("p", {
    className: "guideNotes"
  }, /*#__PURE__*/_react["default"].createElement("strong", {
    className: "staffScriptItem"
  }, "Note:"), " You can only discuss the cover options that align with the customers stated cover needs in the previous question."), /*#__PURE__*/_react["default"].createElement(_staffCoverOptionsMessage.StaffCoverOptionsMessage, null)), /*#__PURE__*/_react["default"].createElement("div", {
    className: "additionalNotes"
  }, /*#__PURE__*/_react["default"].createElement("fieldset", {
    className: "expertModeToggle"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "labelText"
  }, "Toggle expert mode"), /*#__PURE__*/_react["default"].createElement(_components.OnOffSwitch, {
    fieldFormContext: formContext,
    id: "expertModeSwitch",
    name: "expertModeSwitch",
    checked: staffExpertMode,
    onChange: HandleExpertModeChange
  })), /*#__PURE__*/_react["default"].createElement("p", {
    className: "guideNotes"
  }, "If there are questions on any of the options, you may use the following."), speciesFilter === 'FELINE' && staffInstructions.productGroupScriptCat, speciesFilter !== 'FELINE' && staffInstructions.productGroupScriptDog, /*#__PURE__*/_react["default"].createElement(_components.SectionWrapper, {
    isOpen: false,
    heading: 'Examples of accidents'
  }, /*#__PURE__*/_react["default"].createElement("p", null, "Examples of accidents are:"), /*#__PURE__*/_react["default"].createElement("ul", null, /*#__PURE__*/_react["default"].createElement("li", null, "Motor vehicle incidents"), /*#__PURE__*/_react["default"].createElement("li", null, "A reaction to a bite from an insect, spider or scorpion"), /*#__PURE__*/_react["default"].createElement("li", null, "Bite wounds or fight wound abscesses"), /*#__PURE__*/_react["default"].createElement("li", null, "Snake bite toxicity"))), /*#__PURE__*/_react["default"].createElement("p", {
    className: "guideNotes"
  }, "Note: More information can be found by hovering over the tooltip icons.", /*#__PURE__*/_react["default"].createElement(_components.Tooltip, null, "Demo tooltip")))));
};
StaffModePreScripting.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  formContext: _propTypes["default"].any,
  dataIsUpdating: _propTypes["default"].bool,
  isExpertMode: _propTypes["default"].bool,
  onExpertModeChange: _propTypes["default"].func,
  quotesContext: _propTypes["default"].shape(_quoteHelpers.SimplifiedQuoteContextPropTypes),
  onPaymentFrequencyChange: _propTypes["default"].func
};